'use strict';

var linchpin = require('int_googletagmanager/linchpin/recipe');

exports.init = function () {

		$('#wishlist-table .recipes .option-update button').on('click', function (e) {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.removeRecipeEvent(e);
			}
		});

		$('.wishlist-wrapper a.print').on('click', function (e) {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.printRecipe(e);
			}
		});

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.viewRecipeEvent();
		}
};
